const ShipsyAdapter = require('./data-access/adapter')
const createBatchHelpers = require('./batches')
const createReturnToSupplier = require('./handlers/return-to-supplier')
const createInventoryAdjustment = require('./handlers/inventory-adjustment')
const createGrnCreation = require('./handlers/grn-creation')
const createInvoiceCallback = require('./handlers/invoice-callback')
const createSalesReturn = require('./handlers/sales-return')
const { recordTransaction } = require('./transactions')

class ShipsyApi {
  constructor (shipsyApiConfigs = {}, isomorphicFetch, agaveAdapter, logger, user, pgConnection, mainApi) {
    this.fetch = isomorphicFetch
    this.agaveAdapter = agaveAdapter
    this.pgConnection = pgConnection
    this.logger = logger
    this.user = user
    this.mainApi = mainApi
    this.shipsyAdapter = new ShipsyAdapter(shipsyApiConfigs, this.fetch, logger, mainApi)
    const batchHelpers = createBatchHelpers({ mainApi, logger })
    this.batchHelpers = batchHelpers
    this.handlers = {
      returnToSupplier: createReturnToSupplier({ mainApi, batches: batchHelpers }),
      inventoryAdjustment: createInventoryAdjustment({ mainApi, logger, batches: batchHelpers }),
      grnCreation: createGrnCreation({ mainApi, logger, batches: batchHelpers }),
      invoiceCallback: createInvoiceCallback({ mainApi, logger, batches: batchHelpers }),
      salesReturn: createSalesReturn({ mainApi, logger, batches: batchHelpers })
    }
  }

  async runHandler (type, handlerName, params) {
    this.logger.info({ type, handler: handlerName }, 'shipsy: recording stock transactions before running handler')

    // Record transaction before running handler
    await recordTransaction(type, params, { mainApi: this.mainApi, logger: this.logger })
    return this.handlers[handlerName](params)
  }

  returnToSupplier (params = {}) {
    return this.runHandler('rtv', 'returnToSupplier', params)
  }

  inventoryAdjustment (params) {
    return this.runHandler('adjustment', 'inventoryAdjustment', params)
  }

  grnCreation (params) {
    return this.runHandler('grn', 'grnCreation', params)
  }

  invoiceCallback (params) {
    return this.runHandler('invoice', 'invoiceCallback', params)
  }

  salesReturn (params) {
    return this.runHandler('sales_return', 'salesReturn', params)
  }
}

module.exports = ShipsyApi
